(function(window, document, $, undefined){
  
  // -----------------------------------------------------------------------------------------------------
  // PAGINATION
  // -----------------------------------------------------------------------------------------------------
// /page/ version
  // $('.pagination .pagination_select').on('change', 'select', function(e) {
  //   e.preventDefault();
  //   var page = $(this).val();
  //   var location = window.location.href;
  //   var re = new RegExp(/\/page\/.*/);
  //   if(page==1){
  //     location = location.replace(re, '');//remove /page/?/
  //   } else {
  //     if(re.test(location)){
  //       location = location.replace(re, "/page/"+page+'/');
  //     } else {
  //       location += 'page/'+page+'/';
  //     }
  //   }
  //   console.log(location);
  //   window.location.href = location;
  //   // console.log($(this).val());

  //   /* Act on the event */
  // });


function setGetParameter(paramName, paramValue)
{
    var url = window.location.href;
    var hash = location.hash;
    url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0)
    {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else
    {
    if (url.indexOf("?") < 0)
        url += "?" + paramName + "=" + paramValue;
    else
        url += "&" + paramName + "=" + paramValue;
    }
    window.location.href = url + hash;
}

  $('#content').on('change', '.pagination .pagination_select select', function(e) {
  // $('.pagination .pagination_select').on('change', 'select', function(e) {
    e.preventDefault();
    var page = $(this).val();

    setGetParameter('sf_paged',page);

    // var location = window.location.href;
    // var re = new RegExp(/\/paged\/.*/);
    // if(page==1){
    //   location = location.replace(re, '');//remove /page/?/
    // } else {
    //   if(re.test(location)){
    //     location = location.replace(re, "/page/"+page+'/');
    //   } else {
    //     location += 'page/'+page+'/';
    //   }
    // }
    // console.log(location);
    // window.location.href = location;
    // console.log($(this).val());

    /* Act on the event */
  });



})(window, document, jQuery);
